import router from './router'
import missingMessages from './localization'

export default {
  router,
  localization: missingMessages,
}
